// @todo: should be moved to a shared language package?
import { useConfigHelper } from '@ilteducation/config';
export const getMarketLanguage = () => {
  const { countryCode } = useConfigHelper();

  switch (countryCode) {
    case 'no':
      return 'nb';
    case 'fi':
      return 'fi';
    default:
      return 'sv';
  }
};
